export default __webpack_public_path__ + "static/media/WhiteStarDesktop.722bec6b.svg";